<div class="spinner-default" *ngIf="isDefault">
  <div class="rect1"></div>
  <div class="rect2"></div>
  <div class="rect3"></div>
  <div class="rect4"></div>
  <div class="rect5"></div>
</div>

<div class="spinner-round" *ngIf="isRound"></div>